import { useState, useCallback } from 'react';
import axios from 'axios';
import {
  TotalCost,
  TotalEnrolled,
  formatTotalCost,
  formatTotalEnrolled,
} from '../../helper-utils/summaryReportHelper';
import properties from '../../properties';
import { useAPIPayload } from '../../helper-utils/apiPayloadHelper';

const useTotalEligible = (
  startDate: string,
  endDate: string,
  employerGroupStore: any,
  signal?: AbortSignal,
) => {
  const [overAllEnrolled, setOverAllEnrolled] = useState<TotalEnrolled>({
    totalCount: '',
    dependents: '',
    employees: '',
  });

  const [overallTotalCost, setOverallTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const payload = useAPIPayload();

  const getTotalEligible = useCallback(async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.summaryBaseUrl,
        {
          ...payload,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
          claim_id_list: [],
          member_unique_id_list: [],
        },
        { signal },
      )
      .then((response) => {
        if (response.status === 200) {
          const cost = formatTotalCost(response.data?.data, 2);
          const members = formatTotalEnrolled(response.data?.data);
          setOverallTotalCost(cost);
          setOverAllEnrolled(members);
        }
      });
  }, [startDate, endDate, employerGroupStore]);

  return {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  };
};

export default useTotalEligible;
